import ErrorPage from './error'
import DashboardPage from './dashboard'

export {
    ErrorPage,
    DashboardPage,
}